import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from 'components/Loading';
import EstimatorForm from './components/estimatorForm';
import { createEstimator, navigate, requestWorkroomList,
         listOfRequests, clearValidationErrors, requestAllStores } from 'actionCreators';
import { getEstimatorErrors, getWorkroomList, getRole, getPosition,
         getManageVendorWorkrooms } from '../../../../reducers';
import connectUI from 'redux-ui';

class EstimatorNew extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = () => { this.props.navigate('/estimators'); };
    this.state = { all_fetched: false };
    this.handleTabChange = index => this.props.updateUI('activeTab', index);
  }

  componentDidMount = () => this.props.listOfRequests([
    this.props.requestWorkroomList(), this.props.requestAllStores()])
      .then(() => this.setState({ all_fetched: true }));

  componentWillUnmount = () => this.props.clearValidationErrors('ESTIMATOR');

  handleSave = estimator => this.props.createEstimator(estimator).then(() =>
    this.props.updateUI('successMessage', `Estimator ${estimator.user_attributes.name} has been created`));

  render = () => {
    const { errors, allWorkrooms = null, ui, role } = this.props;
    const ready = this.state.all_fetched && allWorkrooms;
    return (ready ? <EstimatorForm
      errors={errors}
      onSave={this.handleSave}
      onCancel={this.handleCancel}
      allWorkrooms={allWorkrooms}
      activeTab={ui.activeTab}
      onTabChange={this.handleTabChange}
      role={role}
      position={this.props.position}
      mvw={this.props.mvw}
    /> : <Loading />);
  }
}

EstimatorNew.propTypes = {
  navigate: PropTypes.func,
  listOfRequests: PropTypes.func,
  requestWorkroomList: PropTypes.func,
  requestAllStores: PropTypes.func,
  clearValidationErrors: PropTypes.func,
  createEstimator: PropTypes.func,
  updateUI: PropTypes.func,
  allStores: PropTypes.array,
  allWorkrooms: PropTypes.array,
  errors: PropTypes.object,
  ui: PropTypes.object,
  role: PropTypes.string,
  position: PropTypes.string,
  mvw: PropTypes.object,
};

const mapStateToProps = state => ({
  allWorkrooms: getWorkroomList(state),
  errors: getEstimatorErrors(state) || {},
  role: getRole(state),
  position: getPosition(state),
  mvw: getManageVendorWorkrooms(state),
});

export default connectUI()(connect(mapStateToProps, {
  navigate,
  createEstimator,
  requestWorkroomList,
  listOfRequests,
  clearValidationErrors,
  requestAllStores,
})(EstimatorNew));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/estimatorNew.jsx